import type { ComparisonTree } from './schema'

/**
 * Rewrites every SINGLE leaf and leaves the AND/OR/ALWAYS structure alone. A subject that borrows the
 * shared editor spells its own operands in the editor's vocabulary on the way in and back on the way
 * out, and only the leaf differs between the two directions.
 *
 * The leaf type comes from the callback alone: inferring it from the tree as well would land on the
 * constraint, since a union target gives inference nothing better to pick.
 */
export const mapComparisonLeaves = <TIn extends { type: 'SINGLE' }, TOut extends { type: 'SINGLE' }>(
  comparison: ComparisonTree<NoInfer<TIn>>,
  mapLeaf: (leaf: TIn) => TOut
): ComparisonTree<TOut> => {
  if (comparison.type === 'SINGLE') return mapLeaf(comparison)
  if (comparison.type === 'ALWAYS') return comparison
  return { ...comparison, items: comparison.items.map((item) => mapComparisonLeaves(item, mapLeaf)) }
}
